module.exports = __webpack_public_path__ + "img/work-icon.a318ef19.svg";